if($('.in-index').length){
    $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
          });
        });
    });
    const storageKey = "homepagesubcategorie";
    function getLang() {
      return $("html").attr("lang") || "en";
    }
    function getFromStorage(lang) {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        return parsed[lang] || null;
      }
      return null;
    }
    function saveToStorage(lang, data) {
      let existing = sessionStorage.getItem(storageKey);
      existing = existing ? JSON.parse(existing) : {};
      existing[lang] = data;
      sessionStorage.setItem(storageKey, JSON.stringify(existing));
    }
    function renderHtml(html) {
        const $html = $("<div>").html(html);
        const $ul = $html.find("ul.subcategories.with-image");
    
        if ($ul.length) {
       
          $(".subcategories-container").html($ul);
          fixImageSrcs($ul);
        } else {
          console.warn("Nebyla nalezena žádná struktura k vykreslení.");
        }
    }    
    function fixImageSrcs($ul) {
        $ul.find("li .image img").each(function () {
          const $img = $(this);
          const src = $img.data("src");
          if (src && src.includes("/thumb/")) {
            $img.attr("src", src.replace("/thumb/", "/orig/"));
            $img.attr("data-src", src.replace("/thumb/", "/orig/"));
          }
        });
    }
    function loadAndRender(lang) {
        const cached = getFromStorage(lang);
        if (cached) {
          renderHtml(cached);
        } else {
          const url = urlMap[lang];
          if (!url) {
            console.warn("Chybí URL pro jazyk:", lang);
            return;
          }
    
          $.get(url, function (response) {
            const temp = $("<div>").html(response);
            const extracted = temp.find("ul.subcategories.with-image").first();
    
            if (extracted.length) {
              fixImageSrcs(extracted);
              const html = extracted.prop("outerHTML");
              saveToStorage(lang, html);
              renderHtml(html);
            } else {
              console.warn("Struktura nenalezena na stránce:", url);
            }
          }).fail(function () {
            console.error("Chyba při načítání URL:", url);
          });
        }
      }

    const currentLang = getLang();
    loadAndRender(currentLang);
    window.switchLanguage = function (newLang) {
      $("html").attr("lang", newLang);
      loadAndRender(newLang);
    };
}